import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'hooks/use-translation';

const Text = styled.p`
  margin-top: var(--spacing-03);
`;

export const SalesforceAuthExpire: FC<{ reauthenticateUrl: string }> = ({
  reauthenticateUrl,
}) => {
  const message = useTranslation('project.overview.auth_error_salesforce_card');
  const reauth = useTranslation('project.overview.salesforce_card_reauth');

  return (
    <div>
      <Text>
        {message}
        <a href={reauthenticateUrl}>{reauth}.</a>
      </Text>
    </div>
  );
};
